import { render, staticRenderFns } from "./BlogSectionArticlesCarousel.vue?vue&type=template&id=496e9348&scoped=true&lang=pug&"
import script from "./BlogSectionArticlesCarousel.vue?vue&type=script&lang=js&"
export * from "./BlogSectionArticlesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./BlogSectionArticlesCarousel.vue?vue&type=style&index=0&id=496e9348&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496e9348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('496e9348')) {
      api.createRecord('496e9348', component.options)
    } else {
      api.reload('496e9348', component.options)
    }
    module.hot.accept("./BlogSectionArticlesCarousel.vue?vue&type=template&id=496e9348&scoped=true&lang=pug&", function () {
      api.rerender('496e9348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/BlogSectionArticlesCarousel.vue"
export default component.exports